module.exports = __webpack_public_path__ + "public/images/partners/sup-10.9b77fe47b4238db3a72906f523f919b0.png";